// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__q-hF_","option":"styles_option__1wftM","active":"styles_active__2evwm"};